export const WORK_MANAGEMENT_TABS = Object.freeze([
  { text: '업무 목록', value: 'works', group: 'work' },
  { text: '내 할일', value: 'my-items', group: 'work' },
  { text: '알림', value: 'notifications', group: 'work' },
  { text: '업무 진행 상황 로그', value: 'progress-logs', group: 'work' },
  { text: '템플릿', value: 'templates', group: 'settings' },
  { text: 'Runtime 설정', value: 'runtime-definitions', group: 'settings' },
  { text: '외부 이벤트', value: 'external-events', group: 'settings' },
])

export function workManagementTabsForEnvironment() {
  return WORK_MANAGEMENT_TABS
}

export function workManagementVisibleTabs(organizationPermission = '') {
  return organizationPermission === 'super_admin'
    ? WORK_MANAGEMENT_TABS
    : WORK_MANAGEMENT_TABS.filter(tab => tab.value !== 'external-events')
}

const ROUTE_TAB_MAP = Object.freeze({
  WorkManagement: 'works',
  WorkDetail: 'works',
  WorkItemRedirect: 'works',
  MyWorkItems: 'my-items',
  WorkNotifications: 'notifications',
  WorkProgressLogs: 'progress-logs',
  WorkTemplateLayout: 'templates',
  WorkTemplateList: 'templates',
  WorkTemplateCreate: 'templates',
  WorkTemplateDetail: 'templates',
  WorkTemplatePublish: 'templates',
  RuntimeDefinitionList: 'runtime-definitions',
  RuntimeDefinitionCreate: 'runtime-definitions',
  RuntimeDefinitionDetail: 'runtime-definitions',
  WorkExternalEvents: 'external-events',
})

export function workManagementTabPath(projectId, value) {
  const base = `/work-management/${projectId}`
  if (value === 'works') return base
  return `${base}/${value}`
}

export function workManagementActiveTab(routeName) {
  return ROUTE_TAB_MAP[routeName] || 'works'
}

export function isWorkManagementRouteName(routeName) {
  return (
    routeName === 'WorkManagementLayout' ||
    Object.prototype.hasOwnProperty.call(ROUTE_TAB_MAP, routeName)
  )
}

const WORK_TEMPLATE_DETAIL_TABS = new Set([
  'basic',
  'items',
  'flow',
  'permissions',
  'notifications',
  'revisions',
])

export function workTemplateDetailNavigationState(query = {}) {
  const requestedTab = Array.isArray(query.tab) ? query.tab[0] : query.tab
  const activeTab = WORK_TEMPLATE_DETAIL_TABS.has(String(requestedTab || ''))
    ? String(requestedTab)
    : 'basic'
  const requestedNodeKey = Array.isArray(query.node_key) ? query.node_key[0] : query.node_key
  const selectedNodeKey = activeTab === 'flow' && requestedNodeKey != null && requestedNodeKey !== ''
    ? String(requestedNodeKey)
    : null
  return { activeTab, selectedNodeKey }
}

export function workTemplateRuleReturnPath({ projectId, templateId, nodeKey } = {}) {
  if (projectId == null || projectId === '' || templateId == null || templateId === '') return null
  const path = `/work-management/${encodeURIComponent(projectId)}/templates/${encodeURIComponent(templateId)}`
  const query = ['tab=flow']
  if (nodeKey != null && nodeKey !== '') query.push(`node_key=${encodeURIComponent(nodeKey)}`)
  return `${path}?${query.join('&')}`
}

export function runtimeDefinitionReturnTarget({ returnTo, projectId, templateId, nodeKey } = {}) {
  const projectPath = projectId == null || projectId === ''
    ? ''
    : `/work-management/${encodeURIComponent(projectId)}/`
  const requestedPath = Array.isArray(returnTo) ? returnTo[0] : returnTo
  if (projectPath && typeof requestedPath === 'string' && requestedPath.startsWith(projectPath)) {
    return requestedPath
  }
  return workTemplateRuleReturnPath({ projectId, templateId, nodeKey })
}
